import type { MaskedPlayerLane as PlayerLane } from '@completto/shared';
import { html, View } from 'rune-ts';

export type MiniLaneTone = 'me' | 'opponent';

export type MiniLaneData = {
  lane: PlayerLane;
  tone?: MiniLaneTone;
};

const GROUP_SIZES = [5, 5, 5, 5, 2] as const;

export class MiniLaneView extends View<MiniLaneData> {
  override template() {
    const tone: MiniLaneTone = this.data.tone ?? 'me';
    const upCls =
      tone === 'opponent' ? 'bg-card-deep text-card-gold' : 'bg-card-navy text-card-gold';
    const downCls =
      tone === 'opponent' ? 'bg-wood-coffee/70 text-transparent' : 'bg-wood-bark text-transparent';

    const groups: ReturnType<typeof html>[] = [];
    let cursor = 0;
    for (let g = 0; g < GROUP_SIZES.length; g++) {
      const size = GROUP_SIZES[g] as number;
      const cells: ReturnType<typeof html>[] = [];
      for (let i = 0; i < size; i++) {
        const slot = this.data.lane.slots[cursor + i];
        if (!slot) continue;
        const isUp = slot.tile.face === 'UP';
        const display = isUp ? (slot.tile.resolvedNumber ?? slot.tile.number) : null;
        const cellCls = isUp ? upCls : downCls;
        // 3자리 숫자(100)는 폰트 축소로 셀 안에 깔끔하게 수용
        const isThreeDigit = display !== null && display >= 100;
        const fontCls = isThreeDigit
          ? 'text-[11px] mlandscape:text-[10px] tracking-tighter'
          : 'text-xs mlandscape:text-xs tabular-nums';
        cells.push(
          html`<span class="inline-flex items-center justify-center w-[18px] h-[22px] mlandscape:w-[18px] mlandscape:h-[22px] rounded font-bold leading-none ${fontCls} ${cellCls}">${display ?? ''}</span>`,
        );
      }
      cursor += size;
      groups.push(html`<span class="inline-flex gap-0.5">${cells}</span>`);
    }
    return html`<div class="mini-lane inline-flex items-center gap-1 shrink-0 px-1.5">${groups}</div>`;
  }
}
